// useBreakpoint.js
import { useEffect, useState } from "react";

// NOTE: must preserve order
export const breakpointsOrder = ["2xl", "xl", "lg", "md", "sm"] as const;

export type Breakpoint = (typeof breakpointsOrder)[number];

const getBreakpoint = (width: number): Breakpoint | null => {
  if (width >= 1536) return "2xl";
  if (width >= 1280) return "xl";
  if (width >= 1024) return "lg";
  if (width >= 768) return "md";
  if (width >= 640) return "sm";
  return null;
};

export const useBreakpoint = (): Breakpoint | null => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null);

  useEffect(() => {
    const handleResize = (): void => {
      const nextBreakpoint = getBreakpoint(window.innerWidth);
      setBreakpoint(nextBreakpoint);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return breakpoint;
};
